export enum FIELDS_NAMES {
  validFromDate = 'Valid From Date',
  validUntilDate = 'Valid Until Date',
  officialFirstName = 'Official First name',
  officialLastName = 'Official Last name',
  officialMiddleName = 'Official Middle name',
  firstName = 'First name',
  lastName = 'Last name',
  schoolCode = 'SchoolCode',
  country = 'Country',
  state = 'State',
  zip = 'Zip',
  city = 'City',
  address = 'Address',
  ada = 'ADA',
  examId = 'Exam ID',
  email = 'Email',
}

export const COUNTRY_DEPENDENT_FIELDS: FIELDS_NAMES[] = [
  FIELDS_NAMES.zip,
  FIELDS_NAMES.city,
  FIELDS_NAMES.address,
  FIELDS_NAMES.state,
];
